import { lazy } from 'react';
import { centerModalOption } from '../../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { ConfirmationPageProps } from './ConfirmationPageContent';

const ConfirmationPageContent = lazy(() => import('./ConfirmationPageContent'));

const ConfirmationPage = wrapLazyNavigatorScreen(
  (props: ConfirmationPageProps) => {
    return <ConfirmationPageContent {...props} />;
  },
  centerModalOption,
);

export default ConfirmationPage;
